/**
 * Ensure "standard" forms can only be submitted once.
 * This prevents a chromium browser issue where multiple
 * form submissions can be made.
 *
 * Ref:
 * - https://support.google.com/chrome/thread/8616084/chrome-new-release-75-submits-forms-twice-causing-duplicate-data-to-be-saved-across-all-pages?hl=en
 * - https://bugs.chromium.org/p/chromium/issues/detail?id=977882
 */
// eslint-disable-next-line import/prefer-default-export
export const limitStandardFormSubmission = () => {
    // "standard" SilverStripe forms includes login, reset password etc.
    const forms = document.querySelectorAll('form:not(.userform)');

    // eslint-disable-next-line no-use-before-define
    forms.forEach(limitFormSubmission);
};

const limitFormSubmission = (form) => {
    form.addEventListener('submit', function () {
        // eslint-disable-next-line no-undef
        const formIsValid = $(this).valid();

        if (formIsValid === false) {
            return;
        }

        // eslint-disable-next-line no-use-before-define
        disableSubmitButton(form);
    });
};

const disableSubmitButton = (form) => {
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton == null) {
        return;
    }

    submitButton.setAttribute('disabled', true);
};
